import * as React from 'react';
import { Typography } from '@mui/material';

/** Props for {@link MLabel}. */
export interface IMLabelProps extends Omit<React.ComponentProps<typeof Typography>, 'children'> {
    /** React list key (not forwarded to `Typography`, consumed by React itself). */
    key?: React.Key;
    /** Label text. */
    name: React.ReactNode;
    /** `Typography` variant. Defaults to `h5`. */
    h?: React.ComponentProps<typeof Typography>['variant'];
    /** Inline style override. Defaults to `{ marginTop: 10, marginBottom: 0 }`. */
    style?: React.CSSProperties;
}

/**
 * Shared label/heading used throughout the rule edit dialog.
 * @param props - `key`, `name` (text), `h` (Typography variant, default `h5`), `style`, plus pass-through `Typography` props.
 */
export const MLabel: React.FC<IMLabelProps> = ({ key, name, h, style, ...props }) => {
    return (
        <Typography {...props} variant={h ? h : 'h5'} style={style ? style : { marginTop: 10, marginBottom: 0 }} gutterBottom flex="1" key={key}>
            {name}
        </Typography>
    );
};